import {mapProfileComparisonResponse} from '../serializers/ProfileComparisonSerializers';
import type {ProfileComparisonResult} from '../types/ProfileComparisonTypes';

import {useApiRead} from '../../../../hooks/useApiRead';
import {GetRoutes} from '../../../../lib/api/GET/GetRoutes';

interface ProfileComparisonResultState {
  data: ProfileComparisonResult | null;
  isLoading: boolean;
  isFetching: boolean;
  error: unknown;
}

export const useProfileComparisonResult = (
  companyId: string,
  profileAPublicId: string | null,
  profileBPublicId: string | null,
): ProfileComparisonResultState => {
  const enabled =
    !!companyId && !!profileAPublicId && !!profileBPublicId && profileAPublicId !== profileBPublicId;

  const path = enabled
    ? GetRoutes.companyWorkforceProfilesCompare(companyId, profileAPublicId, profileBPublicId)
    : '';

  const result = useApiRead<ProfileComparisonResult>({
    path,
    camelCaseOverride: mapProfileComparisonResponse,
    options: {
      enabled,
      queryKey: ['profileComparison', companyId, profileAPublicId, profileBPublicId],
    },
  });

  return {
    data: result.data ?? null,
    isLoading: result.isLoading,
    isFetching: result.isFetching,
    error: result.error,
  };
};
